// extracted by mini-css-extract-plugin
export default {"timeContainer":"ExerciseDuration_timeContainer__ID8-n","timeInput":"ExerciseDuration_timeInput__AR6Sa"};